export const isLivePreviewEnabled = ['test', 'staging'].includes(process.env.GATSBY_ENV!);
export const isNewApplicationFormEnabled = ['test'].includes(process.env.GATSBY_ENV!);
export const isPersonalizeEnabled = ['test', 'staging'].includes(process.env.GATSBY_ENV!);
export const isMonitoringEnabled = () => ['production'].includes(process.env.GATSBY_ENV!);
